import '../../modules/inputValidate';

const setReadonlyIfExists = (selector, readonly) => {
    const field = document.querySelector(selector);
    if (field) {
        field.readOnly = readonly;
    }
};

document.querySelector('[name="targeted_delivery"]')?.addEventListener('change', function (event) {
    const target = (event && (event.currentTarget || event.target)) || this;
    if (!target || typeof target.checked === 'undefined') {
        return;
    }
    const readonly = !target.checked;
    setReadonlyIfExists('[name="targeted_delivery_radius"]', readonly);
    setReadonlyIfExists('[name="targeted_delivery_price"]', readonly);
    setReadonlyIfExists('[name="delivery_price_per_item"]', readonly);
    setReadonlyIfExists('[name="delivery_price_max"]', readonly);
    setReadonlyIfExists('[name="message_for_client"]', readonly);
});

document.querySelector('[name="pickup"]')?.addEventListener('change', function (event) {
    const target = (event && (event.currentTarget || event.target)) || this;
    if (!target || typeof target.checked === 'undefined') {
        return;
    }
    let inputs = document.querySelectorAll('[name^="pickup_points"]');
    for (let i = 0; i < inputs.length; i++) {
        let input = inputs[i];
        if (input.tagName === 'INPUT' && input.type !== 'hidden' || input.tagName === 'TEXTAREA' && input.type !== 'hidden') {
            input.readOnly = input.hasAttribute('data-readonly') || !target.checked;
        }
    }
    let addBtn = document.getElementById('js-pickup-btn-add');
    if(addBtn){
        if(target.checked){
            addBtn.classList.remove('d-none')
        }else{
            addBtn.classList.add('d-none')
        }
    }
})
if (window.pickupPointsView) {
    let pointClass = 'js-pickup-point'
    let points = document.getElementById('js-pickup-points');
    let addBtn = document.getElementById('js-pickup-btn-add');

    addBtn.addEventListener('click', function () {
        let html = window.pickupPointsView;

        let id = Math.round(Math.random() * 10e6)
        html = html.replaceAll('pickup_points[new]', 'pickup_points[new_'+id+']');
        html = html.replaceAll('id="', 'id="pickup-'+id+'-');
        points.insertAdjacentHTML('beforeend', html);
        init();
    });
    init();

    function init() {
        $(".js-pickup-point-address").suggestions({
            token: "7adee2df98d5d1b6a1479bded0c82872415afe00",
            type: "ADDRESS",
            /* Вызывается, когда пользователь выбирает одну из подсказок */
            onSelect: function (suggestion) {
                let pointElement = this;
                for (let i = 0; i < 20; i++) {
                    if (pointElement.tagName === 'BODY' || pointElement.classList.contains(pointClass)) {
                        break;
                    }
                    pointElement = pointElement.parentNode;
                }
                if (pointElement.tagName !== 'BODY') {
                    let latInput = pointElement.querySelector('.js-pickup-point-lat');
                    let lonInput = pointElement.querySelector('.js-pickup-point-lon');

                    if (latInput) {
                        latInput.value = suggestion.data.geo_lat;
                    }
                    if (lonInput) {
                        lonInput.value = suggestion.data.geo_lon;
                    }
                }
            }
        });
    }
}
